import styles from './ListHelper.scss';

const ListHelper = ({primaryText, secondaryText}) => {
    return (
        <div className={styles.ListHelper} data-cy="ListHelper">
            <p className={styles.ListHelper__primaryText} data-cy="ListHelper-primaryText">{primaryText}</p>
            <p className={styles.ListHelper__secondaryText} data-cy="ListHelper-secondaryText">{secondaryText}</p>
        </div>
    );
};

export default ListHelper;
